import { FGTile, FGStack, FGTypography } from '@fg/design-system';
import { CountryBadge } from 'components/eventsFeed/CountryBadge';
import { MOMENTJS_DATE_DISPLAY_FORMAT } from '../../../constants';
import { IActiveCountry } from 'interfaces';
import moment from 'moment';
import React from 'react';
import { PredictionWithDateString } from './Predictions';
import cx from 'classnames';

const OUTCOME_COLORS: Record<string, string> = {
    correct: 'var(--fg-color-base-green-11)',
    incorrect: 'var(--fg-color-base-red-11)',
    pending: 'var(--fg-color-base-blue-11)',
};

const OUTCOME_BG_COLORS: Record<string, string> = {
    correct: 'var(--fg-color-base-green-3)',
    incorrect: 'var(--fg-color-base-red-3)',
    pending: 'var(--fg-color-base-blue-3)',
};

type Props = {
    prediction: PredictionWithDateString;
    countriesById: { [countryID: number]: IActiveCountry };
    onClick: (id: number) => void;
    isActive?: boolean;
};

const PredictionItem = React.memo(
    ({ prediction, countriesById, onClick, isActive }: Props) => {
        const country = countriesById[prediction.country_id];
        return (
            <FGTile
                className={cx('event-item-container', {
                    'active-event': isActive,
                })}
                alignItems="flex-start"
                onClick={() => onClick(prediction.id)}>
                <FGStack direction="column" gap={8} alignItems="flex-start">
                    {country && (
                        <FGStack gap={8} style={{ flexWrap: 'wrap' }}>
                            <CountryBadge country={country} />
                        </FGStack>
                    )}
                    <FGStack gap={4} direction="column" alignItems="flex-start">
                        <FGTypography
                            alignment="left"
                            variant="body3-long"
                            color="strong"
                            tag="label">
                            {prediction.abbreviation}
                        </FGTypography>
                        <FGTypography variant="body4" tag="label" color="weak">
                            Call made on{' '}
                            {moment(Date.parse(prediction.call_date)).format(
                                MOMENTJS_DATE_DISPLAY_FORMAT
                            )}
                        </FGTypography>
                    </FGStack>
                    <FGTypography
                        variant="body4"
                        tag="label"
                        cssStyle={{
                            color: OUTCOME_COLORS[prediction.outcome],
                            backgroundColor:
                                OUTCOME_BG_COLORS[prediction.outcome],
                            borderRadius: 3,
                            padding: '2px 4px',
                            textTransform: 'capitalize',
                        }}>
                        {prediction.outcome}
                    </FGTypography>
                </FGStack>
            </FGTile>
        );
    }
);

export default PredictionItem;